// API配置文件
const API_CONFIG = {
  // 基础域名
  BASE_URL: 'https://deer.cpcc-sh.cn:8089',
  
  // 接口端点
  ENDPOINTS: {
    // 商品分类管理
    PRODUCT_TYPE_LIST: '/productType/searchProductType',
    
    // 商品管理
    PRODUCT_LIST: '/productManage/searchProductList',
    
    // 桌台号管理
    TABLE_NUMBER_LIST: '/tableNumManage/searchTableNumList',
    
    // 图片下载
    DOWNLOAD_IMAGE: '/picture/downloadImage',
    
    // 订单管理
    PRINT_ORDER: '/print/printOrder',
    SEARCH_ORDER_LIST: '/order/searchOrderList',
    SEARCH_ORDER_DETAIL: '/order/searchOrderDetail',
    PRINT_ORDER_DETAIL: '/order/printOrderDetail'
  }
};

// 构建完整的API URL
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// 导出常用的API URLs
export const API_URLS = {
  PRODUCT_TYPE_LIST: buildApiUrl(API_CONFIG.ENDPOINTS.PRODUCT_TYPE_LIST),
  PRODUCT_LIST: buildApiUrl(API_CONFIG.ENDPOINTS.PRODUCT_LIST),
  TABLE_NUMBER_LIST: buildApiUrl(API_CONFIG.ENDPOINTS.TABLE_NUMBER_LIST),
  DOWNLOAD_IMAGE: buildApiUrl(API_CONFIG.ENDPOINTS.DOWNLOAD_IMAGE),
  PRINT_ORDER: buildApiUrl(API_CONFIG.ENDPOINTS.PRINT_ORDER),
  SEARCH_ORDER_LIST: buildApiUrl(API_CONFIG.ENDPOINTS.SEARCH_ORDER_LIST),
  SEARCH_ORDER_DETAIL: buildApiUrl(API_CONFIG.ENDPOINTS.SEARCH_ORDER_DETAIL),
  PRINT_ORDER_DETAIL: buildApiUrl(API_CONFIG.ENDPOINTS.PRINT_ORDER_DETAIL)
};

export default API_CONFIG; 